export default {
  methods: {
    validateFileSize(file, max = 10) {
      const fileSize = file.size / 1024 / 1024
      const valid = fileSize < max
      if (!valid) {
        this.$buefy.snackbar.open({
          type: 'is-danger',
          position: 'is-top',
          message: `File is too big. Max upload size is ${max}mb`
        })
      }

      return valid
    }
  }
}
